export default "__VITE_ASSET__Dwhn3X9L__"